import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { Users, UsersState, UserTypes } from './types';

const INITIAL_STATE: UsersState = {
    data: {} as Users,
    loading: true,
    hasError: false,
    error: undefined,
    success: false,
};

const reducer: Reducer<UsersState> = (state: UsersState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case UserTypes.GET_USERS_REQUEST:
            return { ...state, loading: true };
        case UserTypes.GET_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: { ...state.data, users: action.payload.data, total: action.payload.total },
            };
        case UserTypes.GET_USERS_FAILURE:
            return {
                ...state,
                loading: false,
                hasError: true,
                error: action.payload,
            };
        case UserTypes.POST_FEEDBACK_REQUEST:
            return { ...state, loading: true };
        case UserTypes.POST_FEEDBACK_SUCCESS:
            return { ...state, loading: false, success: true };
        case UserTypes.POST_FEEDBACK_FAILURE:
            return { ...state, loading: false, hasError: true, error: { ...action.payload } };
        case UserTypes.POST_FEEDBACK_CLEAR:
            return { ...state, loading: false, hasError: false, error: undefined, success: false };
        case UserTypes.POST_USER_REQUEST:
        case UserTypes.POST_USER_SUCCESS:
        case UserTypes.POST_USER_FAILURE:
        case UserTypes.GET_USERS_CLEAR:
        case UserTypes.POST_USER_CLEAR:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default reducer;
